/**
 * Event Modal
 * @format
 */

import React, { useState } from 'react';
import Translate from '@components/translation/translate-text-wrapper';
import ModalWrapper from '@varian/scripts/components/modals/modal-wrapper';

/**
 * Images Container.
 *
 * @param param
 * @returns
 */
const ModalImageGallery: React.FC<{
  title: string;
  image: string;
  altTag: string;
}> = ({ title, image, altTag }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  /**
   * Open Modal Link.
   */
  const openImageModal = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    event.preventDefault();
    setShowModal(true);
  };

  /**
   * Render.
   */
  return (
    <div>
      {/* Thumbnail */}
      <div className="gallery-thumbnail">
        <div
          className={`img-container`}
          onClick={(event) => openImageModal(event)}>
          <img
            data-src={`https://varian.widen.net/content/${image}/png?w=360&crop=false`}
            alt={altTag}
            className={`lazy`}
          />
        </div>
        <p className="font-size-base-sm">{title}</p>
      </div>

      {/* Modal */}
      {image && (
        <ModalWrapper showModal={showModal} setShowModal={setShowModal}>
          <div className="modal-image-container">
            <img
              data-src={`https://varian.widen.net/content/${image}/webp?w=720&crop=false`}
              alt={altTag}
              className="lazy"
            />
          </div>

          <h4>{title}</h4>
          <div className={`link-container small-vertical-margin`}>
            <a
              href={`https://varian.widen.net/content/${image}/webp`}
              target="_blank"
              className="img-download">
              <Translate>Download image</Translate>
            </a>
          </div>
        </ModalWrapper>
      )}
    </div>
  );
};
export default ModalImageGallery;
